import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';
import { ApplicationStatus, ApplicationCategory } from '../../types';

export const FilterFormComponent = () => {
    const applicationStatusOptions = [
        { value: '', label: 'All Statuses' },
        { value: ApplicationStatus.ACTIVE, label: 'Active' },
        { value: ApplicationStatus.INACTIVE, label: 'Inactive' },
    ];

    const applicationCategoryOptions = [
        { value: '', label: 'All Categories' },
        { value: ApplicationCategory.ADMIN, label: 'Admin' },
        { value: ApplicationCategory.BUSINESS, label: 'Business' },
        { value: ApplicationCategory.CONSUMER, label: 'Consumer' },
    ];

    return (
        <>
            <Field
                name="applicationStatus"
                label="Application Status"
                data={applicationStatusOptions}
                component={FormikRadioGroup}
                my="md"
            />

            <Field
                name="applicationCategory"
                label="Application Category"
                data={applicationCategoryOptions}
                component={FormikRadioGroup}
                my="md"
            />
        </>
    );
};
